import { CompareUtil } from "@base/util/CompareUtil";
import { SelectionData, SelectionType } from "@biz/definitions/SelectionDefinitions";

/** @deprecated */
export type TreePath = readonly string[];
export type ItemSelectionType = "item" | "child";
export type LockState = false | "locked" | "lockedTransform";

export interface ILayerData {
  hidden?: boolean;
  locked?: LockState;
  notOrderable?: boolean;
  name?: string;
  parentId?: string;
}

/** @deprecated use GroupHelper */
export class LayerHelper {
  static _getLayerStackForSelectionType(selectionType: SelectionType): TreePath {
    return LayerHelper.getLayerStackForLayerId(standardLayerIdsForSelectionType[selectionType]);
  }

  static getLayerStackForLayerId(id: string): TreePath {
    let current: string | undefined = id;
    const result: string[] = [];
    while (current) {
      result.unshift(current);
      current = layers[current as LayerId];
    }
    return result;
  }

  static #getLayerIdForSelection(selection: SelectionData | undefined): string | undefined {
    if (!selection)
      return undefined;
    return standardLayerIdsForSelectionType[selection.type];
  }

  static _calcSelectionType(id: string, selections: SelectionData[]): ItemSelectionType | undefined {
    if (!id)
      return undefined;

    const selectionLayerIds = selections.map((LayerHelper.#getLayerIdForSelection))
    for (const s of selections) {
      if (s.id === id)
        return "item";
    }

    const layerStack = LayerHelper.getLayerStackForLayerId(id);
    if (!layerStack) {
      return undefined;
    }
    for (const slid of selectionLayerIds) {
      if (slid) {
        const stack = LayerHelper.getLayerStackForLayerId(slid);
        if (CompareUtil.arrayStartsWith(stack, layerStack))
          return "child"
      }
    }

    return undefined;
  }
}

type LayerId = "products" | "surroundings" | "grounds" | "models" | "walls" | "fences" | "sandboxes" | "roofs" | "openings" | "groups";

const layers: Record<LayerId, LayerId | undefined> = {
  products: undefined,
  surroundings: undefined,
  grounds: "surroundings",
  models: "surroundings",
  walls: "surroundings",
  fences: "surroundings",
  roofs: "surroundings",
  openings: "surroundings",
  sandboxes: "surroundings",
  groups: undefined
};

// todo: new product
const standardLayerIdsForSelectionType: Record<SelectionType, LayerId> = {
  sunSail: "products",
  raff: "products",
  curtain: "products",
  lounge: "products",
  modelProduct: "products",
  ground: "grounds",
  model: "models",
  wall: "walls",
  fence: "fences",
  sandbox: "sandboxes",
  roof: "roofs",
  opening: "openings",
  group: "groups",
  net: "products"
} as const
